export default class EnvironmentVariableNotSet extends Error {
  constructor(name: string) {
    super(`Environment variable not set: ${name}`)

    this.name = 'EnvironmentVariableNotSet'
  }
}
